export default "__VITE_ASSET__3416dce4__"